import { MarketingMaterialTableItem } from "shared/types/marketingMaterials";
import { isDeliverable } from "utils/helpers.salesEnablement";

export const isDeliverablePrint = (material: MarketingMaterialTableItem) => {
  return (
    material.templateDeliveryMethods?.includes("print") &&
    isDeliverable(material)
  );
};
